import React, {Component} from 'react'
import Autocomplete from 'react-autocomplete'
import request from './../../utils/requestConfig'
import './index.css'

class Search extends Component {
  state = {
    value: '',
    items: []
  }
  handleChange = (e) => {
    this.setState({ value: e.target.value })
  }
  handleSearch = (e) => {
    e.preventDefault()
    const keyCode = e.which || e.keyCode
    const ENTER = 13
    const { value } = e.target

    if (keyCode === ENTER) {
      this.setState({ value: e.target.value })
      this.props.changeSearchTerm(value)
    }
  }
  handleClick = () => {
    this.props.changeSearchTerm(this.state.value)
  }

  searchOnKeyPress = e => {
    if (e.key === 'Enter') this.props.changeSearchTerm(this.state.value)
  }

  render () {
    return (
      <div className='modal__search-container'>
        <Autocomplete
          inputProps={{className: 'modal__search', type: 'text', onKeyPress: this.searchOnKeyPress}}
          wrapperStyle={{ display: 'inline-block', width: '100%' }}
          value={this.state.value}
          items={this.state.items}
          getItemValue={(item) => item.name}
          onSelect={(value, item) => {
            this.setState({ value, items: [ item ] })
            this.props.changeSearchTerm(value)
          }}
          onChange={(event, value) => {
            this.setState({ value })
            this.setState({ items: [] })
            if (value !== '' && value.length > 3) {
              request.get('/books/search', {
                params: {
                  terms: value,
                  per: 20,
                  page: 1
                }
              })
                .then(({ data }) => {
                  this.setState({ items: data })
                })
            }
          }}
          renderMenu={children => (
            <div className='menu'>
              {children}
            </div>
          )}
          renderItem={(item, isHighlighted) => (
            <div
              className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
              key={item.id}
            >{item.name}</div>
          )}
        />
        <button onClick={this.handleClick} className='button is-primary'>Pesquisar</button>
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search/index.js